<template>
  <div class="pricing-area pb-75 position-relative z-1">
    <div class="container mw-1356">
      <div
        class="section-title mw-860 m-auto text-center"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <span class="top-title">باقات الاشتراكات</span>
        <h2>باقات اشتراك تنافسية</h2>
      </div>

      <ul
        class="nav nav-tabs justify-content-center pricing-tabs"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            :class="['tab', { active: activeTab === 'internet' }]"
            @click="setActiveTab('internet')"
          >
            اشتراك أساسي
          </button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link"
            :class="['tab', { active: activeTab === 'tv' }]"
            @click="setActiveTab('tv')"
          >
            اشتراك عائلي
          </button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link"
            :class="['tab', { active: activeTab === 'homeSecurity' }]"
            @click="setActiveTab('homeSecurity')"
          >
            اشتراك VIP
          </button>
        </li>
      </ul>

      <div class="tab-content">
        <div v-show="activeTab === 'internet'">
          <div class="row justify-content-center">
            <div
              class="col-xl-4 col-md-6"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <div class="pricing-single-item">
                <span class="ignite d-block">
                  احصل على أفضل جودة بـ 15 دولار شهرياً
                </span>
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-1.png" alt="pricing" />
                  <h3>باقة المبتدئين</h3>
                  <p>
                    اشتراك لمدة شهر واحد. استمتع بكل القنوات العالمية بجودة عالية وثبات مستمر.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">عدد الأجهزة</span>
                      <span class="mbps"><span>1</span> جهاز</span>
                    </div>
                    <div class="download">
                      <span class="speed">الدعم الفني</span>
                      <span class="mbps"><span>24</span> ساعة</span>
                    </div>
                  </div>
                  <span class="unlimited">استخدام غير محدود</span>
                  <h2>$ 15.00<sub>/ شهرياً</sub></h2>
                  <RouterLink to="/contact-us" class="btn active">
                    <span class="border-style">اشترك الآن</span>
                  </RouterLink>
                </div>
              </div>
            </div>
            <div
              class="col-xl-4 col-md-6"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <div class="pricing-single-item active">
                <span class="ignite d-block">
                  الأكثر طلباً في أوروبا بـ 25 دولار
                </span>
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-2.png" alt="pricing" />
                  <h3>الباقة العائلية</h3>
                  <p>
                    اشتراك مرن ومناسب للعائلات. دعم كامل للقنوات الترفيهية والرياضية.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">عدد الأجهزة</span>
                      <span class="mbps"><span>2</span> جهاز</span>
                    </div>
                    <div class="download">
                      <span class="speed">جودة البث</span>
                      <span class="mbps"><span>4K</span> UHD</span>
                    </div>
                  </div>
                  <span class="unlimited">استخدام غير محدود</span>
                  <h2>$ 25.00<sub>/ شهرياً</sub></h2>
                  <RouterLink to="/contact-us" class="btn active">
                    <span class="border-style">اشترك الآن</span>
                  </RouterLink>
                </div>
              </div>
            </div>
            <div
              class="col-xl-4 col-md-6"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <div class="pricing-single-item">
                <span class="ignite d-block">
                  تغطية شاملة لكل القنوات العالمية
                </span>
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-3.png" alt="pricing" />
                  <h3>باقة الـ VIP</h3>
                  <p>
                    اشتراك متكامل مع مكتبة أفلام ضخمة وتحديثات يومية مستمرة.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">عدد الأجهزة</span>
                      <span class="mbps"><span>3</span> أجهزة</span>
                    </div>
                    <div class="download">
                      <span class="speed">أولوية الدعم</span>
                      <span class="mbps"><span>قصوى</span></span>
                    </div>
                  </div>
                  <span class="unlimited">استخدام غير محدود</span>
                  <h2>$ 40.00<sub>/ شهرياً</sub></h2>
                  <RouterLink to="/contact-us" class="btn active">
                    <span class="border-style">اشترك الآن</span>
                  </RouterLink>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-show="activeTab === 'tv'">
          <div class="row justify-content-center">
            <div class="col-xl-4 col-md-6">
              <div class="pricing-single-item">
                <span class="ignite d-block">
                  باقة التجربة السنوية
                </span>
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-1.png" alt="pricing" />
                  <h3>الباقة الأساسية سنوي</h3>
                  <p>
                    اشتراك سنوي اقتصادي يضمن لك توفير المال والحصول على أفضل الخدمات.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">عدد الأجهزة</span>
                      <span class="mbps"><span>1</span> جهاز</span>
                    </div>
                    <div class="download">
                      <span class="speed">الدعم الفني</span>
                      <span class="mbps"><span>دائم</span></span>
                    </div>
                  </div>
                  <span class="unlimited">استخدام غير محدود</span>
                  <h2>$ 120.00<sub>/ سنة</sub></h2>
                  <RouterLink to="/contact-us" class="btn active">
                    <span class="border-style">اشترك الآن</span>
                  </RouterLink>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-md-6">
              <div class="pricing-single-item active">
                <span class="ignite d-block">
                  العرض العائلي المميز للعام
                </span>
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-2.png" alt="pricing" />
                  <h3>الباقة العائلية سنوي</h3>
                  <p>
                    خيارك الأفضل في أوروبا للمشاهدة العائلية المستقرة على مدار السنة.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">عدد الأجهزة</span>
                      <span class="mbps"><span>2</span> جهاز</span>
                    </div>
                    <div class="download">
                      <span class="speed">جودة البث</span>
                      <span class="mbps"><span>4K</span> UHD</span>
                    </div>
                  </div>
                  <span class="unlimited">استخدام غير محدود</span>
                  <h2>$ 200.00<sub>/ سنة</sub></h2>
                  <RouterLink to="/contact-us" class="btn active">
                    <span class="border-style">اشترك الآن</span>
                  </RouterLink>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-md-6">
              <div class="pricing-single-item">
                <span class="ignite d-block">
                  باقة VIP السنوية الشاملة
                </span>
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-3.png" alt="pricing" />
                  <h3>باقة الـ VIP سنوي</h3>
                  <p>
                    تمتع بأقصى مستويات الترفيه في ألمانيا وأوروبا لمدة 12 شهراً كاملة.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">عدد الأجهزة</span>
                      <span class="mbps"><span>3</span> أجهزة</span>
                    </div>
                    <div class="download">
                      <span class="speed">أولوية الدعم</span>
                      <span class="mbps"><span>قصوى</span></span>
                    </div>
                  </div>
                  <span class="unlimited">استخدام غير محدود</span>
                  <h2>$ 350.00<sub>/ سنة</sub></h2>
                  <RouterLink to="/contact-us" class="btn active">
                    <span class="border-style">اشترك الآن</span>
                  </RouterLink>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-show="activeTab === 'homeSecurity'">
          <div class="row justify-content-center">
            <div class="col-xl-4 col-md-6">
              <div class="pricing-single-item">
                <span class="ignite d-block">
                  باقة دعم الخبراء
                </span>
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-1.png" alt="pricing" />
                  <h3>الدعم الفني والتقني</h3>
                  <p>
                    خدمة إضافية للعملاء الذين يحتاجون مساعدة تقنية متقدمة في إعدادات البث.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">المساعدة</span>
                      <span class="mbps"><span>عن بعد</span></span>
                    </div>
                    <div class="download">
                      <span class="speed">التوفر</span>
                      <span class="mbps"><span>24/7</span></span>
                    </div>
                  </div>
                  <span class="unlimited">خدمة احترافية</span>
                  <h2>$ 5.00<sub>/ شهرياً</sub></h2>
                  <RouterLink to="/contact-us" class="btn active">
                    <span class="border-style">اطلب الخدمة</span>
                  </RouterLink>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-md-6">
              <div class="pricing-single-item active">
                <span class="ignite d-block">
                  تجهيز الشاشات الذكية
                </span>
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-2.png" alt="pricing" />
                  <h3>خدمة إعداد الشاشات</h3>
                  <p>
                    نقوم بتنصيب جميع البرامج المطلوبة لتعمل الخدمة على شاشتك بكفاءة 100%.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">التجهيز</span>
                      <span class="mbps"><span>شامل</span></span>
                    </div>
                    <div class="download">
                      <span class="speed">الضمان</span>
                      <span class="mbps"><span>متاح</span></span>
                    </div>
                  </div>
                  <span class="unlimited">خدمة احترافية</span>
                  <h2>$ 10.00<sub>/ مرة</sub></h2>
                  <RouterLink to="/contact-us" class="btn active">
                    <span class="border-style">اطلب الخدمة</span>
                  </RouterLink>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-md-6">
              <div class="pricing-single-item">
                <span class="ignite d-block">
                  باقة الأجهزة المساعدة
                </span>
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-3.png" alt="pricing" />
                  <h3>اشتراك البث المباشر</h3>
                  <p>
                    إضافة قنوات إخبارية ورياضية حصرية تتطلب سرعات عالية وتغطية خاصة.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">التغطية</span>
                      <span class="mbps"><span>عالمية</span></span>
                    </div>
                    <div class="download">
                      <span class="speed">الجودة</span>
                      <span class="mbps"><span>فائقة</span></span>
                    </div>
                  </div>
                  <span class="unlimited">استخدام غير محدود</span>
                  <h2>$ 20.00<sub>/ شهرياً</sub></h2>
                  <RouterLink to="/contact-us" class="btn active">
                    <span class="border-style">اطلب الخدمة</span>
                  </RouterLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "PricingPlans",
  setup() {
    const activeTab = ref("internet");

    const setActiveTab = (tab: string) => {
      activeTab.value = tab;
    };

    return {
      activeTab,
      setActiveTab,
    };
  },
});
</script>